import React from 'react';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
};
export function CtaButton({
  children,
  href = '#offer',
  className = ''
}: CtaButtonProps) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'The Pharma-Masterclave',
      value: 19,
      currency: 'USD'
    });
    if (href.startsWith('#')) {
      const target = document.getElementById(href.slice(1));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  return <a href={href} onClick={handleClick} className={`inline-flex w-full items-center justify-center rounded-xl bg-trust px-8 py-5 text-center text-base font-extrabold uppercase tracking-wide text-white shadow-lg shadow-trust/25 transition-transform duration-150 hover:-translate-y-0.5 hover:bg-trust-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-trust/40 sm:w-auto sm:text-lg ${className}`} style={{
    width: '244px',
    height: '88px'
  }} data-id="element-29" data-mp="vbk05oqcjaxc">
      {children}
    </a>;
}